import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AdminSharedModule } from '@modules/admin-shared/admin-shared.module';
import { ReportsComponent } from '@components/admin/admin/reports/reports.component';
import { TaxReportComponent } from '@components/admin/admin/reports/tax-report/tax-report.component';
import { TaxReportOrdersComponent } from '@components/admin/admin/reports/tax-report/tax-report-orders/tax-report-orders.component';
import { DailyLedgerComponent } from '@components/admin/admin/reports/daily-ledger/daily-ledger.component';
import { TrunkShowReportComponent } from '@components/admin/admin/reports/trunk-show-report/trunk-show-report.component';
import { CustomersReportComponent } from '@components/admin/admin/reports/customers-report/customers-report.component';
import { CustomersEmailComponent } from '@components/admin/admin/reports/customers-email/customers-email.component';
import { CustomersExpiredRxComponent } from '@components/admin/admin/reports/customers-expired-rx/customers-expired-rx.component';

const REPORTS_DECLARATIONS = [
  ReportsComponent,
  TaxReportComponent,
  TaxReportOrdersComponent,
  DailyLedgerComponent,
  TrunkShowReportComponent,
  CustomersReportComponent,
  CustomersEmailComponent,
  CustomersExpiredRxComponent,
];

@NgModule({
  declarations: REPORTS_DECLARATIONS,
  imports: [AdminSharedModule],
  exports: REPORTS_DECLARATIONS,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ReportsModule {}
